export const LANGUAGE_LABEL_LOCALE_ZHCHT = {
    en: 'è±èª',
    "zh-cn": 'ç°¡é«ä¸­æ',
    "zh-CHS": 'ç°¡é«ä¸­æ',
    "zh-CHT": 'ç¹é«ä¸­æ',
    ok: 'ç¢ºå®',
    cancel: 'åæ¶'
};
